export default "__VITE_ASSET__BvVafjft__"